/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
// Must stay the very first import: ES modules evaluate in source order, so the
// polyfills have to be installed before any module that might call one of them
// while it is being evaluated. simple-import-sort has no notion of a
// load-order-critical side-effect import and moves this one to the bottom of
// the chunk, which is exactly what must not happen — hence the disable.
// eslint-disable-next-line simple-import-sort/imports
import './polyfills';

import { createRoot } from 'react-dom/client';

import { defaultTheme, ThemeProvider } from '@spazious/react-styles';
import { initSentry } from '@utils/sentry';

import { MetronicI18nProvider } from './_metronic/i18n';
import {
  MetronicLayoutProvider,
  MetronicSplashScreenProvider,
  MetronicSubheaderProvider,
} from './_metronic/layout';
import App from './app/App';
import configureStore from './store/configureStore';

import './index.css';
// import "./sass/style.react.rtl.css"; // RTL version
import './_metronic/_assets/plugins/flaticon/flaticon.css';
import './_metronic/_assets/plugins/flaticon2/flaticon.css';
import './_metronic/_assets/plugins/keenthemes-icons/font/ki.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'socicon/css/socicon.css';
// Datepicker
import 'react-datepicker/dist/react-datepicker.css';

// Side-effect import: registers all dayjs plugins once, before the app renders,
// so `.utc()`, `.tz()`, etc. are available at every call site app-wide.
import './utils/dayjs';
/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */

const store = configureStore();

const { REACT_APP_URL_BASENAME } = process.env;
// const { PUBLIC_URL } = process.env;

initSentry();

createRoot(document.getElementById('root')).render(
  <MetronicI18nProvider>
    <MetronicLayoutProvider>
      <MetronicSubheaderProvider>
        <MetronicSplashScreenProvider>
          <ThemeProvider theme={defaultTheme}>
            <App basename={REACT_APP_URL_BASENAME} store={store} />
          </ThemeProvider>
        </MetronicSplashScreenProvider>
      </MetronicSubheaderProvider>
    </MetronicLayoutProvider>
  </MetronicI18nProvider>
);
